import { CRUDEntity } from "../abstracts/CRUDEntity";
import { EntityModalForm } from "../abstracts/mixins/EntityModalForm";
import { FormActions } from "../abstracts/mixins/FormActions";
import { PaymentMethodInterface } from "../abstracts/mixins/PaymentMethodInterface";
import { Validator } from "../../snippets/Validator";
import { SaveButton } from "../../components/SaveButton";
// import { loadStripe } from '@stripe/stripe-js';

export const Card = (() => {

    return class Card extends CRUDEntity {
        static PUBLIC_KEY = $('meta[name=stripe-pk]').attr('content');
        static ORG_STRIPE_ID = $('meta[name=org-stripe-id]').attr('content');

        __stripe_lib
        __stripe
        __formId
        __stripeElems
        __submitBtn
        __saveBtn
        cardElems={}

        constructor(id=null, addParams=null) {
            super();
            this.entityClass = 'card';
            this.urlRoot = '/customer/cards';
            this.sectionRootUrl = '/customer';
            this.id = id;
            this.addParams = addParams


            Object.assign(Card.prototype, FormActions);
            Object.assign(Card.prototype, EntityModalForm);
            Object.assign(Card.prototype, PaymentMethodInterface);

            Card.prototype.delegatedListnersForButtons = async function(type, entity){
                const formId = `#${type}-${entity}`
                await import('@stripe/stripe-js').then((modules) => {
                    this.__stripe_lib = modules.loadStripe;
                }).then(()=>{
                    if(type == 'create' || type == 'confirm-card'){
                        if(!this.__stripe){
                            const stripeAccountId = this.stripeAccountId()
                            const stripeOptions = stripeAccountId ? {stripeAccount:stripeAccountId} : undefined
                            this.__stripe_lib(Card.PUBLIC_KEY, stripeOptions).then((resp)=>{
                                this.__stripe = resp;
                            }).then(()=>{
                                this.loadStripeFormPayment(formId)
                            });
                        }else{
                            this.loadStripeFormPayment(formId)
                        }
                    }
                });
                /* if(type == 'create' || type == 'confirm-card'){
                    if(!this.__stripe){
                        this.__stripe = await loadStripe(Card.PUBLIC_KEY, [])
                        console.log(this.__stripe);
                    }
                    await this.loadStripeFormPayment(formId)
                } */
                this.__submitBtn = $(`${formId} button#${type}`)
                this.__saveBtn = new SaveButton(formId);
                $(`${formId} button#${type}`).off();
                $(`${formId} button#${type}`).on('click', () => {
                    if (type == 'create')
                        this.create();
                    if(type == 'confirm-card')
                        this.create();
                    if (type == 'edit')
                        this.update();
                });
            }
            Card.prototype.completeForm = function(formId) {
                if (this.id == null) return;
                const form = $(`form#${formId}`);
                const cardInfo = this.read();
                form.find('[name=expiration_date]').val(this.expirationDateToNeedleFormat(cardInfo.expiration_date));
            }
            Card.prototype.collectDataInForm = function(formId) {
                const form = $(`#${formId}`);
                const dateString = form.find('input[name=expiration_date').val();
                const [month, year] = dateString.split('/');
                const expiration_date = `20${year}-${month}-01`;
                return { expiration_date };
            }
            Card.prototype.delete = async ()=>{
                let response = await super.delete();
                if(response.ok){
                    const row = $(`#customer_card-stafter-table tr[data-id="${this.id}"][data-entity="customer_card"]`)
                    if(row.length) row.remove()
                }
            }
        }

        stripeAccountId(){
            return Card.ORG_STRIPE_ID || null
        }

        create(successCallback, errorCallback){
            const returnUrl = `${location.protocol}//${location.hostname}${this.urlRoot}/success-change`
            this.submitPaymentCard(returnUrl)
        }

        confirmCardData(successCallback = () => {}, errorCallback = () => {}) { // НУЖНО УБРАТЬ
            const cardData = this.collectDataInForm('confirm-card-organisation_card');
            $.ajax({
                url: `${this.urlRoot}/${this.id}/update`,
                method: 'POST',
                data: cardData,
                success: successCallback,
                error: (response) => { errorCallback(response) }
            });
        }

        expirationDateToNeedleFormat = (dateString) => {
            const date = new Date(dateString);
            let month = (date.getMonth() + 1).toString();
            if (month.length == 1) month = '0' + month;
            return `${month}/${date.getFullYear().toString().slice(2)}`;
        }

        loadStripeFormPayment(formId){
            if(!this.__stripe)
                throw new Error('Stripe object not initialized!')
            const options = {
                mode:'setup',
                currency: 'usd',
            }
            const style = {
                base: {
                    color: "#182029",
                    fontFamily: 'Rubik, sans-serif',
                    fontSmoothing: "antialiased",
                    fontSize: "16px",
                    "::placeholder": {
                        color: "#72777D"
                    }
                },
                invalid: {
                    fontFamily: 'Rubik, sans-serif',
                    color: "#DB3A57",
                    iconColor: "#DB3A57"
                }
            }
            this.__stripeElems = this.__stripe.elements(options)
            this.cardElems.number = this.__stripeElems.create('cardNumber', {style})
            this.cardElems.exp = this.__stripeElems.create('cardExpiry', {style})
            this.cardElems.cvc = this.__stripeElems.create('cardCvc', {style})
            this.cardElems.number.mount(`${formId} #card-number`);
            this.cardElems.exp.mount(`${formId} #card-exp`);
            this.cardElems.cvc.mount(`${formId} #card-cvc`);
            $(`${formId} #card-zip`).mask('00000', {placeholder: 'ZIP'});
            this.__formId = formId;
        }

        async submitPaymentCard(url){
            this.__saveBtn.startLoading();
            const validator = new Validator({
                'card-zip': ['required',{regexp: /[0-9]{5}/}],
            });
            const zipCode = $(`${this.__formId} #card-zip`)
            if(!validator.validate('card-zip', zipCode.val())){
                zipCode.css('outline','2px solid #DB3A57');
                this.__saveBtn.stopLoading();
                return
            }else{
                zipCode.css('outline', '')
            }

            this.__submitBtn.attr('disabled',true)
            const secret = $(this.__formId).data('stripe-intent')
            const customerId = $(this.__formId).data('customer-id')
            if(!secret){
                $('#error-message').text('Stripe token is not correct!')
                this.__submitBtn.removeAttr('disabled')
                this.__saveBtn.stopLoading();
                return
            }
            const {error: submitError} = await this.__stripeElems.submit();
            if(submitError){
                $('#error-message').text(submitError.message)
                this.__submitBtn.removeAttr('disabled')
                this.__saveBtn.stopLoading();
                return
            }
            const newUrl = new URL(url)
            if(customerId)
                newUrl.searchParams.set('customer_id', customerId)
            if(this.id != null)
                newUrl.searchParams.set('card_id',this.id)
            if(this.addParams!=null){
                for(const key in this.addParams){
                    newUrl.searchParams.set(key, this.addParams[key])
                }
            }
            this.__stripe.confirmCardSetup(secret, {
                payment_method:{
                    card:this.cardElems.number,
                    billing_details: {
                        address: {
                           postal_code: zipCode.val()
                        }
                    }
                },
                return_url: newUrl.toString()
            }).then(result=>{
                this.__saveBtn.stopLoading()
                if(result?.setupIntent){
                    newUrl.searchParams.set('setup_intent', result.setupIntent.id)
                    fetch(newUrl.toString(), {
                        method: "GET",
                    }).then(response => response.json())
                        .then(() => {
                            this.__saveBtn.showSuccess()
                            this.successSubmitCallback()
                        }).catch(result => {
                            console.error(result)
                            this.__saveBtn.showError()
                            this.__submitBtn.removeAttr('disabled')
                        })
                }else if(result?.error){
                    $('#error-message').text(result.error.message)
                    this.__saveBtn.showError()
                    this.__submitBtn.removeAttr('disabled')
                }
            }).catch(error=>{
                if(error) $('#error-message').text(error.message)
                this.__saveBtn.showError()
                this.__submitBtn.removeAttr('disabled')
            });
        }

        successSubmitCallback(){
            document.location.reload(true)
        }
    }
})();
